/**
 * Home hero — full-bleed background video with a frosted panel that overlaps the
 * video's lower edge (the "Coca-Cola IR" treatment from the mock). The panel
 * carries the brand mark, a stacked uppercase headline, and the mission copy.
 */

import AgntLogo from 'components/agnt-inc/agnt-logo';

import styles from './hero.module.scss';

import type { HeroContent } from '../content';

export default function Hero({ content }: { content: HeroContent }) {
  return (
    <section className={styles.hero}>
      <div className={styles.video}>
        <video autoPlay muted loop playsInline preload="auto">
          <source src={content.videoSrc} type="video/mp4" />
        </video>
        <div className={styles.overlayTop} />
        <div className={styles.overlayBottom} />
      </div>
      <div className={styles.panelWrap}>
        <div className={styles.panel}>
          <AgntLogo className={styles.brand} title={content.brand} />
          <h1 className={styles.headline}>
            {content.headlineLines.map((line, index) => (
              <span key={line}>
                {line}
                {index < content.headlineLines.length - 1 ? <br /> : null}
              </span>
            ))}
          </h1>
          <p className={styles.mission}>{content.mission}</p>
        </div>
      </div>
    </section>
  );
}
